var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"label":_vm.label,"label-cols":_vm.labelCols,"ready":_vm.ready,"items":_vm.workflowTypeList},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }